import { render, staticRenderFns } from "./SocialMedias.vue?vue&type=template&id=52975118&scoped=true"
import script from "./SocialMedias.vue?vue&type=script&lang=js"
export * from "./SocialMedias.vue?vue&type=script&lang=js"
import style0 from "./SocialMedias.vue?vue&type=style&index=0&id=52975118&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52975118",
  null
  
)

export default component.exports